import { createFeature, createReducer, on } from '@ngrx/store';
import {
  authenticated,
  clearToken,
  logoutOAuth,
  restoreSession,
  secondFactorEnforced,
  secondFactorFailed,
  setToken
} from '../actions/session-auth.actions';
import { SessionAuthState } from '../../models/session-auth.state';
import { SecondFactorState } from '../../models/second-factor.state';
import { SESSION_AUTH_STATE_KEY } from '../../data/constants/session-auth-state-key.constant';

const initialState: SessionAuthState = {
  token: null,
  secondFactorState: SecondFactorState.init,
};

const reducer = createReducer(
  initialState,
  on(setToken, authenticated, restoreSession, (state, { token }) => ({
    ...state,
    token,
  })),
  on(clearToken, logoutOAuth, () => initialState),
  on(secondFactorEnforced, (state) => ({
    ...state,
    secondFactorState: SecondFactorState.enforced,
  })),
  on(secondFactorFailed, (state) => ({
    ...state,
    secondFactorState: SecondFactorState.failed,
  })),
);

export const sessionAuthFeature = createFeature({
  name: SESSION_AUTH_STATE_KEY,
  reducer,
});
